// src/com/file_of_report/DeliveryReportGql.js
import { gql } from "@apollo/client";

/*
# ================================
# src/main/resources/graphql/schema/delivery_report.graphqls
# Project: NewTOP for cloud
# 출고실적 레포트
# 운송실적 레포트와 같은 데이터.
# Report 생성 후에 프론트엔드는 폴링 방식으로 결과를 확인.
# ================================

extend type Mutation {
    # 센터, 운송사 무관하게 사용.
    deliveryReportAdd(deliveryReport: InputDeliveryReportAdd!): ResponseWithFileCreateHisItem!
}

# 출고실적 레포트 조회용 입력. 운송사 여부에 따라 서비스 내에서 분기.
input InputDeliveryReportAdd {
    dateFrom: String!
    dateTill: String!
	dcCd: String
    transTypeCd: String
    vehTypeId: String
    comId: String
    storeId: String
    vehPlates: String
}

*/

export const CREATE_DELIVERY_REPORT = gql`
mutation CreateDeliveryReport($deliveryReport:InputDeliveryReportAdd!) {
    deliveryReportAdd(deliveryReport: $deliveryReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;

